import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  const [selected, setSelected] = useState<'kit' | 'pro'>('pro');
  const getLink = () => {
    return selected === 'kit' ? 'https://checkout.kitonline.shop/cart/47876273144046:1' : 'https://checkout.kitonline.shop/cart/47876274290926:1';
  };
  return <section id="pricing" className="bg-white py-4 md:py-6 px-3 border-b border-gray-200" data-id="element-105">
      <div className="max-w-3xl mx-auto" data-id="element-106">
        <h2 className="text-xl md:text-3xl font-black text-[#0B1F3A] text-center mb-3 uppercase tracking-tight" data-id="element-107">
          💣 OFERTA ESPECIAL
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 items-stretch mb-3" data-id="element-108">
          {/* Kit Completo */}
          <div onClick={() => setSelected('kit')} className={`bg-[#F5F5F5] rounded-xl p-3 flex flex-col h-full cursor-pointer transition-all duration-300 border-2 ${selected === 'kit' ? 'border-[#0B1F3A] shadow-lg scale-[1.01]' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-109">
            <div className="flex items-center gap-2 mb-2" data-id="element-110">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selected === 'kit' ? 'border-[#0B1F3A] bg-[#0B1F3A]' : 'border-gray-400 bg-white'}`} data-id="element-111">
                {selected === 'kit' && <Check className="w-3 h-3 text-white" strokeWidth={4} data-id="element-112" />}
              </div>
              <h3 className="text-sm md:text-base font-black text-[#0B1F3A] uppercase" data-id="element-113">
                🎯 KIT COMPLETO
              </h3>
            </div>
            <div className="text-center mb-2" data-id="element-114">
              <div className="text-2xl md:text-3xl font-black text-[#0B1F3A]" data-id="element-115">
                $19.990
              </div>
            </div>
            <ul className="space-y-1" data-id="element-116">
              <li className="flex items-center gap-2 text-gray-800 text-xs md:text-sm font-bold" data-id="element-117">
                <Check className="w-4 h-4 text-[#FF6B00] flex-shrink-0" strokeWidth={3} data-id="element-118" />{' '}
                6 tomos completos
              </li>
              <li className="flex items-center gap-2 text-gray-800 text-xs md:text-sm font-bold" data-id="element-119">
                <Check className="w-4 h-4 text-[#FF6B00] flex-shrink-0" strokeWidth={3} data-id="element-120" />{' '}
                4 bonos de regalo
              </li>
            </ul>
          </div>

          {/* Kit + Sistema Pro */}
          <div onClick={() => setSelected('pro')} className={`bg-[#0B1F3A] rounded-xl p-3 flex flex-col h-full cursor-pointer transition-all duration-300 relative border-2 ${selected === 'pro' ? 'border-[#FF6B00] shadow-lg shadow-[#FF6B00]/20 scale-[1.01]' : 'border-[#0B1F3A] hover:border-gray-700'}`} data-id="element-121">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#FF6B00] text-white font-black px-4 py-0.5 rounded-full text-[10px] tracking-widest uppercase whitespace-nowrap z-10" data-id="element-122">
              ⭐ RECOMENDADO
            </div>

            <div className="flex items-center gap-2 mb-2 mt-1" data-id="element-123">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selected === 'pro' ? 'border-[#FF6B00] bg-[#FF6B00]' : 'border-gray-500 bg-transparent'}`} data-id="element-124">
                {selected === 'pro' && <Check className="w-3 h-3 text-white" strokeWidth={4} data-id="element-125" />}
              </div>
              <h3 className="text-sm md:text-base font-black text-white uppercase" data-id="element-126">
                🚀 KIT + SISTEMA PRO
              </h3>
            </div>

            <div className="text-center mb-2" data-id="element-127">
              <div className="text-2xl md:text-3xl font-black text-[#FF6B00]" data-id="element-128">
                $27.990
              </div>
            </div>

            <p className="text-white font-black text-xs mb-2 border-b border-gray-700 pb-1.5" data-id="element-129">
              ✔ Todo lo anterior +
            </p>

            <div className="bg-white/10 rounded-lg p-2 mb-2 border border-white/20" data-id="element-130">
              <h4 className="font-black text-[#FF6B00] text-xs mb-1.5 uppercase" data-id="element-131">
                💥 SISTEMA PRO DE CLASES DINÁMICAS
              </h4>
              <ul className="space-y-1" data-id="element-132">
                <li className="flex items-start gap-1.5 text-gray-100 text-xs font-bold" data-id="element-133">
                  <Check className="w-3.5 h-3.5 text-[#FF6B00] flex-shrink-0" strokeWidth={3} data-id="element-134" />{' '}
                  Juegos funcionales
                </li>
                <li className="flex items-start gap-1.5 text-gray-100 text-xs font-bold" data-id="element-135">
                  <Check className="w-3.5 h-3.5 text-[#FF6B00] flex-shrink-0" strokeWidth={3} data-id="element-136" />{' '}
                  Dinámicas grupales
                </li>
                <li className="flex items-start gap-1.5 text-gray-100 text-xs font-bold" data-id="element-137">
                  <Check className="w-3.5 h-3.5 text-[#FF6B00] flex-shrink-0" strokeWidth={3} data-id="element-138" />{' '}
                  Estrategias para retener alumnos
                </li>
              </ul>
            </div>

            <p className="text-center text-white font-black text-[10px] md:text-xs" data-id="element-139">
              👉 Para que tus clases destaquen
            </p>
          </div>
        </div>

        <div className="text-center flex justify-center" data-id="element-140">
          <CTAButton href={getLink()} variant="primary" className="w-full max-w-md py-3 text-base md:text-lg" data-id="element-141">
            QUIERO EL KIT COMPLETO
          </CTAButton>
        </div>
      </div>
    </section>;
}